import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDecimalNumber',
})
export class FormatDecimalNumberPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const formatter = new Intl.NumberFormat('en-US'); // Locale-aware formatter

    if (value === 0 || value.toString().split('.')[0].length > 3) {
      return formatter.format(Math.round(value)); // No decimal points for 1000 or more, or for 0
    } else {
      // return formatter.format(parseFloat(value.toFixed(2))); // 2 decimal points for values below 1000
      if (Math.abs(value) < 1e-10) {
        return '0';
      } else {
        return formatter.format(parseFloat(value.toFixed(2))); // 2 decimal points for values below 1000
      }
    }
  }
}
